import { render } from "./HomeATF.vue?vue&type=template&id=48e419b0&scoped=true"
import script from "./HomeATF.vue?vue&type=script&lang=js"
export * from "./HomeATF.vue?vue&type=script&lang=js"

import "./HomeATF.vue?vue&type=style&index=0&id=48e419b0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\sthem\\source\\repos\\Insync\\Pamodzi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e419b0"]])

export default __exports__